import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Hotjar from '@hotjar/browser';

import { MeSelectors } from '../../redux/selectors';
import userRoleCheckers from '../../../../shared/helpers/userRoleCheckers';

const { HOTJAR_ID } = process.env;
const { HOTJAR_VERSION } = process.env;

const HotjarInit = () => {
  const me = useSelector(MeSelectors.selectMe);

  useEffect(() => {
    if ((userRoleCheckers.isCustomer(me?.role) || userRoleCheckers.isWriter(me?.role)) && HOTJAR_ID && HOTJAR_VERSION) {
      Hotjar.init(HOTJAR_ID, HOTJAR_VERSION, { debug: false });
      const {
        email,
        firstName,
        lastName,
        role,
        _id,
      } = me;

      // This starts to work only from business plan or for trial period
      Hotjar.identify(_id, {
        email,
        firstName,
        lastName,
        role,
      });
    }
  }, [me]);

  return null;
};

export default HotjarInit;
